export default __webpack_public_path__ + "media/zurb/img/case-study-paysa/paysa-video-e42547ed81a0081802753b5c148385f0.png";